'use strict';

angular.module('MW.InsDashboard.TransformSov', [
    'CoreColorService',
    'MW.InsDashboard.ChartDataService',
    'MW.Framework.TranslationService',
    'DashboardChartConfigService',
    'MW.Dashboard.DashboardStateService',
    'MW.Dashboard.Base64Service'
])
.factory('TransformSov', [
    'CoreColorService',
    'ChartDataService',
    'translationService',
    'DashboardChartConfigService',
    'DashboardStateService',
    'Base64Service',
    function (
        CoreColorService,
        ChartDataService,
        translationService,
        DashboardChartConfigService,
        DashboardStateService,
        Base64Service) {

        var transformSov;
        var processLineChart = function processLineChart(data, chart) {
            //set x axis date labels
            var category =  ChartDataService.setDateAxis(data[0].datapoints, chart);

            //calculate series
            ChartDataService.setDateSeriesWithLabel(data, formatSovDataPoint, chart).then(function(data) {
                var config = {
                    xAxis:{
                        categories:category
                    },
                    series: data
                };
                /*
                * disable x axis legend when comparing date ranges
                */
                if (chart.fetchDataForPreviousRange) {
                    config.xAxis['labels'] = {
                        enabled:false
                    };
                }
    
                chart.callback(config);
            });
            
        };

        var processBarChart = function processBarChart(data, chart){
            //calculate series
            var series;
            series = setInputSeries(data, chart);

            var config = {
                series:[{
                    data:series
                }]
            };
            chart.callback(config);
        };

        var processTable = function processTable(data, chart){
            var responseData = {};
            var tableData = [];
            var tableSovSummary = [];
            var tableCountSummary = [];
            var pointCount = data[0].totalDatapoints;

            var colTotals = [];
            var rowTotals = [];
            var periodTotal = 0;

            for(var i = 0; i < data.length; i++) {
                colTotals[i] = 0;
            }

            //Calculate Totals
            for(var rowIndex = 0; rowIndex < pointCount; rowIndex++){
                rowTotals[rowIndex] = 0;
                for(var colIndex = 0; colIndex < data.length; colIndex++){
                    rowTotals[rowIndex] += data[colIndex].datapoints[rowIndex].volume;
                    colTotals[colIndex] += data[colIndex].datapoints[rowIndex].volume;
                    periodTotal += data[colIndex].datapoints[rowIndex].volume;
                }
            }

            //Calculate Cell SOVs
            for(var rowIndex = 0; rowIndex < pointCount; rowIndex++){
                var tableRow = {data:[]};

                //Set Label
                tableRow.label =  DashboardChartConfigService.formatTimeInterval(moment(data[0].datapoints[rowIndex].date),chart.queryParameters.granularity, chart.queryParameters.dateStart, chart.queryParameters.dateEnd);

                for(var colIndex = 0; colIndex < data.length; colIndex++){
                    var datapoint = {
                        name: data[colIndex].search.name,
                        volume: data[colIndex].datapoints[rowIndex].volume,
                        date: data[colIndex].datapoints[rowIndex].date,
                        id: data[colIndex].search.id
                    };
                    if(rowTotals[rowIndex] > 0){
                        datapoint.sov = ((data[colIndex].datapoints[rowIndex].volume/rowTotals[rowIndex])*100).toFixed(1) + '%';
                    }
                    tableRow.data.push(datapoint);
                }
                tableData.push(tableRow);
            }

            //Calculate Period SOVs
            for(var colIndex = 0; colIndex < data.length; colIndex++){
                var colSov = ((colTotals[colIndex] / periodTotal) * 100).toFixed(1) + '%';
                tableSovSummary.push(colSov);
                tableCountSummary.push(colTotals[colIndex]);
            }

            responseData.table = tableData;

            if(chart.percentageMode == true){
                responseData.summary = tableSovSummary;
            }else{
                responseData.summary = tableCountSummary;
            }
            chart.callback(responseData);
        };

        const processMwGroupedColumn = function processMwGroupedColumn(data, chart) {
            const chartData = [];
            const colors = [];
            const categories =  ChartDataService.setDateAxis(data[0].datapoints, chart);
            const colorSet = CoreColorService.getColors('default');

            angular.forEach(data, function(series, index) {
                chartData.push({
                    name: series.search.name,
                    id: series.search.id,
                    data: series.datapoints.map((dataPoint, index) => {
                        return {
                            date: dataPoint.date,
                            key: categories[index],
                            value: dataPoint.volume
                        };
                    })
                });

                const encodedInputId = Base64Service.encode(series.search.id);
                const color = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId] || colorSet[index];
                colors.push(color);
            });

            chart.callback({ series: chartData, colors });
        }

        var formatSovDataPoint = function formatSovDataPoint(thisPoint, allPoints, index, chart){
            var dataPoint = chart.dataMap(thisPoint);
            var totalVolumeForThisDate = 0;
            angular.forEach(allPoints, function(comparePoint){
                totalVolumeForThisDate += comparePoint.datapoints[index] ? comparePoint.datapoints[index].volume : 0;
            });
            var percentage = ChartDataService.calculatePercentage(dataPoint.y, totalVolumeForThisDate);
            var point = {
                y:(chart.percentageMode) ? percentage : dataPoint.y,
                indx:index,
                count:dataPoint.y || 0,
                percent:percentage,
                date: (thisPoint.hasOwnProperty('date')) ? thisPoint.date: null, //try to get the date if it exists so that we can use it for drilldowns
                insightsPointData:dataPoint //if another widget wants to use this chart with another data request, all point data is here for flexibility... example, use on tooltip...
            };
            return point;
        };


    var formatSovBarDataPoint = function formatSovBarDataPoint (thisInput, allInputs, index, chart){
        var totalVolumeForThisInput = 0;
        angular.forEach(thisInput.datapoints, function(inputData){
            totalVolumeForThisInput += inputData.volume || 0;
        });

        var totalVolumeForAllInputs = 0,
            totalInputCount = 0;
        angular.forEach(allInputs, function(compareInput){
            totalInputCount++;
            angular.forEach(compareInput.datapoints, function(point){
                totalVolumeForAllInputs += point.volume || 0;
            });
        });
        var percentage = ChartDataService.calculatePercentage(totalVolumeForThisInput, totalVolumeForAllInputs);

        var inputName = thisInput.search.name.toString();
        var series = {
            x:index,
            id: thisInput.search.id,
            name:inputName,
            y:(chart.percentageMode) ? percentage : totalVolumeForThisInput,
            count:totalVolumeForThisInput,
            percent:percentage
        };
        return series;
    };

    var setInputSeries = function setInputSeries(dataSeries, chart){
        var allSeries = [],
            index = 0,
            colorSet = CoreColorService.getColors('default');

        angular.forEach(dataSeries, function foreachInputSeries(series){
            var encodedInputId = Base64Service.encode(series.search.id),
                inputSeries = formatSovBarDataPoint(series, dataSeries, index, chart),
                thisColor = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId];

            if(DashboardStateService.inputIdsToColorMapping.colorIndex === colorSet.length) {
                DashboardStateService.inputIdsToColorMapping.colorIndex = 0;
            }
            if (typeof thisColor === 'undefined') {
                thisColor = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId] = colorSet[DashboardStateService.inputIdsToColorMapping.colorIndex++];
            }
            inputSeries.color = thisColor;
            index++;
            allSeries.push(inputSeries);
        });
        return allSeries;
    };

    transformSov = {
        spline:processLineChart,
        areaspline:processLineChart,
        column:processBarChart,
        donut:processBarChart,
        pie: processBarChart,
        table: processTable,
        mwGroupedColumn: processMwGroupedColumn
    };

    return transformSov;

}]);
